import { useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const withHorizontalScroll = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    const containerRef = useRef(null);
    const [showLeftButton, setShowLeftButton] = useState(false);
    
    const items = props.artists || props.collection || [];
    const [showRightButton, setShowRightButton] = useState(items.length * 300 > window.innerWidth);

    const checkScrollPosition = useCallback(() => {
      const container = containerRef.current;
      if (container) {
        const tolerance = 1;
        const isAtStart = container.scrollLeft <= tolerance;
        const isAtEnd =
          container.scrollLeft + container.clientWidth >=
          container.scrollWidth - tolerance;

        setShowLeftButton(!isAtStart);
        setShowRightButton(!isAtEnd);
      }
    }, []);

    const scroll = (direction) => {
      const container = containerRef.current;
      if (container) {
        const scrollAmount = window.innerWidth;
        const newScrollPosition =
          direction === 'left'
            ? container.scrollLeft - scrollAmount
            : container.scrollLeft + scrollAmount;

        container.scrollTo({
          left: newScrollPosition,
          behavior: 'smooth',
        });

        checkScrollPosition();
      }
    };

    return (
      <WrappedComponent
        {...props}
        containerRef={containerRef}
        showLeftButton={showLeftButton}
        showRightButton={showRightButton}
        scroll={scroll}
        checkScrollPosition={checkScrollPosition}
        navigate={navigate}
      />
    );
  };
};

export default withHorizontalScroll;